export enum MenuPresets {
  DEFAULT = 'default',
  MEDICARE = 'medicare'
}
